import { AbilityBuilder, Ability } from '@casl/ability'

const permissionService = new Ability()

export function definePermissionsFor(user) {
  const { can, cannot, rules } = new AbilityBuilder()
  const regexp = /([a-z]+)\.+([a-z]+)_([a-z_]+)/

  if (user && user.profile) {
    user.profile.permissions.forEach((row) => {
      const per = Object.values(row)[0]
      let array = per.split(regexp)
      console.log("array "+array)
      if (array.length > 2) {
        can(array[2], array[3])
      }
    })
  }
 //console.log(rules)
  return rules
}

export default permissionService
